// Polyfills if needed
import './util/polyfills'

// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_lazy-load.js'

// import local dependencies
import Detection from './util/Detection';
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import refs from './routes/referencesPage';
import report from './routes/report';
import contact from './routes/contact';
import services from './routes/servicesPage';
import news from './routes/news';
import career from './routes/careerPage';
import regulation from './routes/regulationPage';
import company from './routes/companyPage';
import training from './routes/trainingPage';

// Detect browser supports
window._detect = new Detection({ detect: ['ie11', 'edge']});
window._detect.init();

// /** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  'homePage': home,
  'referencesPage': refs,
  'report1Page': report,
  'contactPage': contact,
  'servicesPage': services,
  'newsPage': news,
  'careerPage': career,
  'reportPage': report,
  'planingPage': report,
  'regulationPage': regulation,
  'companyPage': company,
  'trainingPage': training,
});

// // Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js